import { type HttpInterceptorFn } from '@angular/common/http';
import { type EnvironmentProviders, type Provider } from '@angular/core';

/**
 * Hook for the mock mode (AGENTS.md, section 4). Empty in every real build. The `mock` configuration of
 * angular.json swaps this file for mock-providers.mock.ts, so the sample data and the fake sign-in are only
 * reachable from there and never end up in a production bundle.
 */
export const MOCK_PROVIDERS: Array<Provider | EnvironmentProviders> = [];
export const MOCK_INTERCEPTORS: HttpInterceptorFn[] = [];
